module.exports = __webpack_public_path__ + "img/boiler.9ef7346c.png";